var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"simple-mind-map-container"},[_c('div',{ref:"mindMapContainerRef",staticClass:"mind-map-container"}),(_vm.showMask)?_c('div',{staticClass:"mark"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }